var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39355 16C12.8118 16 16.3936 12.4183 16.3936 8C16.3936 3.58172 12.8118 0 8.39355 0C3.97528 0 0.393555 3.58172 0.393555 8C0.393555 12.4183 3.97528 16 8.39355 16Z",
    fill: "url(#paint0_linear_1090_12463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72293 7.9306L9.11021 5.71095C9.642 5.47973 11.4455 4.73985 11.4455 4.73985C11.4455 4.73985 12.2778 4.41615 12.2085 5.20228C12.1854 5.52598 12.0004 6.65892 11.8154 7.88436L11.2374 11.5144C11.2374 11.5144 11.1911 12.0462 10.7981 12.1387C10.405 12.2312 9.75761 11.815 9.642 11.7225C9.54952 11.6531 7.9079 10.6127 7.30674 10.104C7.14489 9.96528 6.95992 9.68782 7.32987 9.36413C8.16224 8.60112 9.15646 7.65314 9.75761 7.05199C10.0351 6.77453 10.3125 6.12713 9.15646 6.91326L5.89634 9.10979C5.89634 9.10979 5.5264 9.341 4.83276 9.13291C4.13911 8.92482 3.32987 8.64736 3.32987 8.64736C3.32987 8.64736 2.77495 8.30054 3.72293 7.9306Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1090_12463",
    x1: 11.0608,
    y1: 2.66728,
    x2: 7.06084,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTg);
export default __webpack_public_path__ + "static/media/social_tg.b19c64200a1578eef7feded3f0e7e8ff.svg";
export { ForwardRef as ReactComponent };